import { TOTAL_BONES } from '../app/constants';
import { bonesFound } from '../app/state';

export interface QuestIndicator {
  element: HTMLElement;
  refresh(): void;
}

/** Indicateur discret « Os retrouvés : n / 3 », repliable et jamais bloquant. */
export function createQuestIndicator(): QuestIndicator {
  const element = document.createElement('div');
  element.className = 'quest';

  // La loupe et les trois os disent de quoi il s'agit avant même de lire le
  // compteur, et rattachent l'indicateur à l'enquête plutôt qu'à un score.
  const embleme = document.createElement('img');
  embleme.className = 'quest__emblem';
  embleme.src = '/props/prop-enquete.png';
  embleme.alt = '';
  embleme.decoding = 'async';

  const summary = document.createElement('output');
  summary.className = 'quest__count';
  summary.setAttribute('aria-live', 'polite');

  const toggle = document.createElement('button');
  toggle.type = 'button';
  toggle.className = 'quest__toggle';
  toggle.setAttribute('aria-expanded', 'true');
  toggle.setAttribute('aria-label', 'Replier l’indicateur de quête');
  toggle.textContent = '–';

  toggle.addEventListener('click', () => {
    const collapsed = element.classList.toggle('is-collapsed');
    toggle.setAttribute('aria-expanded', String(!collapsed));
    toggle.setAttribute(
      'aria-label',
      collapsed ? 'Déplier l’indicateur de quête' : 'Replier l’indicateur de quête',
    );
    toggle.textContent = collapsed ? '+' : '–';
  });

  element.append(embleme, summary, toggle);

  function refresh(): void {
    summary.textContent = `Os retrouvés : ${bonesFound()} / ${TOTAL_BONES}`;
  }

  refresh();
  return { element, refresh };
}
